import React from 'react'
import PropTypes from 'prop-types'
import { BLOCK_TYPES, FIELD_TYPES } from './constants'

import { BlockModel, NULL as BlockModelNULL } from './model'

const getComponentByType = (component) => {
  switch (component.type) {
    case BLOCK_TYPES.SECTION:
      return require('../Section').default

    case BLOCK_TYPES.IMAGE:
      return require('../blocks/Image').default

    case BLOCK_TYPES.VIDEO:
      return require('../blocks/Video').default

    case BLOCK_TYPES.BUTTON:
      return require('../blocks/Button').default

    case BLOCK_TYPES.SIMPLE_BUTTON:
      return require('../blocks/SimpleButton').default

    case BLOCK_TYPES.SUBMIT_BUTTON:
      return require('../blocks/SubmitButton').default

    case BLOCK_TYPES.CONFIRM_BUTTON:
      return require('../blocks/ConfirmButton').default

    case BLOCK_TYPES.DIVIDER:
      return require('../blocks/Divider').default

    case BLOCK_TYPES.SPACING:
      return require('../blocks/Spacing').default

    case BLOCK_TYPES.SHARE:
    case BLOCK_TYPES.FOLLOW:
      return require('../blocks/Social').default

    case BLOCK_TYPES.SHARE_V2:
    case BLOCK_TYPES.FOLLOW_V2:
      return require('../blocks/SocialV2').default

    case BLOCK_TYPES.TEXT:
      return require('../blocks/Text').default

    case BLOCK_TYPES.HTML:
      return require('../blocks/Html').default

    case BLOCK_TYPES.FORM:
      return require('../blocks/Form').default

    case BLOCK_TYPES.TIMER:
      return require('../blocks/Timer').default

    case BLOCK_TYPES.BANNER:
      return require('../blocks/Banner').default

    case BLOCK_TYPES.PRODUCT:
      return require('../blocks/Product').default

    case BLOCK_TYPES.FIELD: {
      switch (component.fieldType) {
        case FIELD_TYPES.LONG_TEXT:
          return require('../fields/LongText').default
        case FIELD_TYPES.SELECT_MANY:
          return require('../fields/SelectMany').default
        case FIELD_TYPES.SELECT_ONE:
          return require('../fields/SelectOne').default
        case FIELD_TYPES.SHORT_TEXT:
          return require('../fields/ShortText').default
        case FIELD_TYPES.SCALE:
          return require('../fields/Scale').default
      }
    }

    default:
      return null
  }
}

const RenderBlockByType = ({ component = BlockModelNULL }) => {
  const BlockComponent = getComponentByType(component)

  return (
    <If condition={BlockComponent}>
      <BlockComponent model={component} />
    </If>
  )
}

RenderBlockByType.propTypes = {
  component: PropTypes.instanceOf(BlockModel),
}

export default RenderBlockByType
